import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import IndustriesPage from './pages/IndustriesPage';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';
import Insights from './pages/Insights';
import InsightArticle from './pages/InsightArticle';
import ServiceDetailPage from './pages/ServiceDetailPage';
import SubServiceDetailPage from './pages/SubServiceDetailPage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import CaseStudy1 from './pages/CaseStudy1';
import CaseStudy2 from './pages/CaseStudy2';
import CaseStudy3 from './pages/CaseStudy3';
import CaseStudy4 from './pages/CaseStudy4';
import ScrollToTopHandler from './components/ScrollToTopHandler';

function AppRouter() {
  return (
    <Router>
      <ScrollToTopHandler />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:serviceSlug" element={<ServiceDetailPage />} />
        <Route path="/industries" element={<IndustriesPage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:articleId" element={<InsightArticle />} />
        <Route path="/services/:serviceSlug/:subSlug" element={<SubServiceDetailPage />} />
        <Route path="/case-studies" element={<CaseStudiesPage />} />
        <Route path="/case-studies/banking" element={<CaseStudy1 />} />
        <Route path="/case-studies/financial-services" element={<CaseStudy2 />} />
        <Route path="/case-studies/insurance" element={<CaseStudy3 />} />
        <Route path="/case-studies/airline" element={<CaseStudy4 />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default AppRouter;
